export const SEASONS_FEATURE_TOKEN = 'seasons'
